import script from "./tableContent.vue?vue&type=script&setup=true&lang=js"
export * from "./tableContent.vue?vue&type=script&setup=true&lang=js"

import "./tableContent.vue?vue&type=style&index=0&id=39e22d21&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39e22d21"]])

export default __exports__